export function RemoveAccent(text: string, charToReplace: string = '', newChar: string = ''): string {
    let newText = text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

    if (!!charToReplace) {
        newText = newText.replace(charToReplace, newChar);
    }

    return newText;
}